import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useSession } from '../hooks/session';
import { Button, Card, Input } from '../components/ui';
import { alert, haptic } from '../lib/telegram';

const TIMEZONES = [
  ['Europe/Kaliningrad', 'Калининград (МСК−1)'],
  ['Europe/Moscow', 'Москва (МСК)'],
  ['Europe/Samara', 'Самара (МСК+1)'],
  ['Asia/Yekaterinburg', 'Екатеринбург (МСК+2)'],
  ['Asia/Omsk', 'Омск (МСК+3)'],
  ['Asia/Krasnoyarsk', 'Красноярск (МСК+4)'],
  ['Asia/Irkutsk', 'Иркутск (МСК+5)'],
  ['Asia/Yakutsk', 'Якутск (МСК+6)'],
  ['Asia/Vladivostok', 'Владивосток (МСК+7)'],
] as const;

/** Первый экран: создание организации. Подключение площадок — следующий шаг мастера. */
export function OnboardingPage() {
  const session = useSession();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [timezone, setTimezone] = useState('Europe/Moscow');
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (name.trim().length < 2) {
      alert('Введите название организации');
      return;
    }
    setSaving(true);
    try {
      const organization = await api.createOrganization(name.trim(), timezone);
      await session.refresh();
      session.selectOrganization(organization.id);
      haptic.success();
      navigate('/feed', { replace: true });
    } catch (error) {
      haptic.error();
      alert(error instanceof Error ? error.message : 'Не удалось создать организацию');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="safe-top mx-auto max-w-lg px-4 pb-10">
      <div className="py-8 text-center">
        <div className="mb-3 text-5xl" aria-hidden="true">📣</div>
        <h1 className="t-large-title">Отзывы под контролем</h1>
        <p className="mt-2 t-callout leading-relaxed text-[var(--color-hint)]">
          Соберём отзывы из 2ГИС и Яндекс Карт в одну ленту, подготовим ответы и покажем, что происходит с репутацией.
        </p>
      </div>

      <Card className="mb-4">
        <label className="mb-1.5 block t-footnote text-[var(--color-hint)]">Название организации</label>
        <Input
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder="Например, Кофейня «Тёплое место»"
          autoFocus
        />

        <label className="mt-4 mb-1.5 block t-footnote text-[var(--color-hint)]">Часовой пояс</label>
        <select
          value={timezone}
          onChange={(event) => setTimezone(event.target.value)}
          className="min-h-11 w-full rounded-[var(--radius-control)] bg-[var(--color-surface)] px-3 t-body text-[var(--color-text)] outline-none"
        >
          {TIMEZONES.map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
        <p className="mt-2 t-caption text-[var(--color-hint)]">
          По нему считается время ответов и время отправки дайджестов.
        </p>
      </Card>

      <Button className="w-full" loading={saving} onClick={() => void submit()}>
        Продолжить
      </Button>
    </div>
  );
}
